/**
 * Created by lari on 03/05/2017.
 */
(function () {
  'use strict';
  angular.module('vcexam')
    .component('examstarter', {
      restrict: 'E',
      bindings: {
        // templates: '=',
        consult: '='
      },
      template: `
      <div class="spacer-bottom" data-hook="examstarter">
        <span ng-repeat="et in vm.examtemplates | orderBy: 'template.nr'" ng-show="vm.examtemplates">
          <span class="btn btn-spacer-top btn-primary" ng-class="{'btn-info': et.template.includefindings, 'btn-warning': et.template.isgdt,'btn-success': et.template.isdicom}"
                data-exam-type="{{et.template.type}}"
                ng-click="vm.startExam(et);">{{et.template.displayname}} <span ng-if="et.template.isgdt">({{vm.getsharename(et.template.gdtsoftwareshareid)}})</span>
          </span>
        </span>
      </div>
      <div class="spacer-top alert alert-warning" ng-show="vm.gdterror">
        <h3><span class="pull-left"><i class="fa fa-warning"></i> GDT Konflikt</span><span class="pull-right"><span class="btn btn-warning" ng-click="vm.cleargdterror()"><i class="fa fa-remove"></i></span></span></h3>
        <div class="clearfix"></div>
        <p ng-bind-html="vm.gdterror"></p>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Exam', 'Examtemplate', '$http', 'lodash', 'Cart',
        function ($log, Exam, Examtemplate, $http, ld, Cart) {
          let vm = this;
          vm.startExam = startExam;

          vm.cleargdterror = function () {
            delete vm.gdterror;
          };

          vm.getsharename = function (s){
            if (s.length > 0) {return s.split("$")[1];} else return;
          };

          vm.$onInit = function () {
            vm.examtemplates = Examtemplate.$search({active: true});
            // vm.examinations = Exam.$search({active: true, open: true, patientid: vm.consult.patientid});
          };


          function startExam(et) {
            let newexam = {};
            newexam.templateid = et._id;
            newexam.print = true;
            newexam.patientid = vm.consult.patientid;
            newexam.clientid = vm.consult.patientid;
            newexam.consultid = vm.consult._id;
            newexam.patlastname = vm.consult.patlastname;
            newexam.patfirstname = vm.consult.patfirstname;
            newexam.patbdate = vm.consult.patbdate;
            newexam.templateid = et._id;
            newexam.template = angular.copy(et.template);
            newexam.type = et.template.displayname;
            newexam.fdate = moment().locale('de-at').format('ll');

            if (et.template.loadfiles === true && et.template.shareid) {
              newexam.shareid = et.template.shareid;
            }
            if (et.template.isdicom === true && angular.isDefined(et.template.dicommodalityaetitle) && et.template.dicommodalityaetitle.length > 0) {
              newexam.isdicom = true;
              newexam.dicommodalitytype = et.template.dicommodalitytype;
              newexam.dicommodalityaetitle = et.template.dicommodalityaetitle;
              newexam.dicomexamid = moment().valueOf().toString() + Math.floor(Math.random() * 999).toString();
              newexam.dicompatname = newexam.patlastname.toUpperCase() + '^' + newexam.patfirstname.toUpperCase();
              newexam.dicomdob = moment(newexam.patbdate, 'DD.MM.YYYY').format('YYYYMMDD');
              newexam.dicomdate = moment().format('YYYYMMDD');
              newexam.dicomtime = moment().format('HHmmss.SS');
              newexam.dicomdescription = et.template.displaytitle;
              newexam.dicompatid = vm.consult.dicompatid;
              newexam.dicomconsultid = vm.consult.dicomconsultid;
            }

            if (et.template.isgdt === true && angular.isDefined(et.template.gdtsoftwareshareid) && angular.isDefined(et.template.gdtprofil)) {
              Exam.$opengdtshare().$then((shares) => {
                $log.debug('open gdt shares', shares);
                let shareparts = et.template.gdtsoftwareshareid.split("$");
                let shareid = shareparts[0];
                let sharename = shareparts[1];
                $log.debug('shares include: ', shares[0].openshares, shares[0].openshares.includes(shareid));
                if (shares[0].openshares.includes(shareid)) {
                  vm.gdterror = `GDT Gerät-Konflikt für Untersuchung <strong>${et.template.displayname}</strong>. 
                    Es kann immer nur eine Untersuchung für die GDT Verbindung <strong>${sharename}</strong> aktiv sein. 
                    Beenden Sie bitte die offene Untersuchung bevor Sie eine neue starten.`;
                  return;
                } else {
                  newexam.isgdt = true;
                  newexam.shareid = shareid;
                  newexam.sharename = sharename;
                  newexam.gdtprofile = et.template.gdtprofil;
                  newexam.gdtpatid = vm.consult.gdtpatid;
                  createExam(newexam);
                }

              });
            } else {
              createExam(newexam);
            }


          }

          function createExam(newexam) {
            Exam.$create(newexam).$then(function (exam) {
              if (angular.isDefined(exam.template.services)) {
                if (angular.isDefined(exam.template.services.groups)) {
                  exam.template.services.groups.map(function (g) {
                    Cart.addItem(exam.patientid, g);
                  });
                }
                // TODO: decide if item details will be fetched by backend upon receiving the request
                if (angular.isDefined(exam.template.services.items)) {
                  exam.template.services.items.map(function (i) {
                    Cart.addItem(exam.patientid, i);
                  });
                }
              }
            });
          }


        }] // controller
    }); // component

// klammerfriedhof
}());